var _            = require('underscore');
var $            = require('jquery');
var Core         = require('../core/core.js');

/**
 * Creates an overlay tray
 *
 * @class
 */

class TrayTabTitle extends Core {

    _defaults() {
        return {
            target: '.js-editor',
            fields: {
                'title': 'no title'
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `
        <div class='editor__tray__tabs__top__title float non-selectable'>
            <a class='editor__tray__tabs__top__title_a js-editor__tray__tabs__top__title_a'>
                <%- title %>
            </a>
        </div>`;

        super.render();

        /**
         * Click title
         *
         * @fires TrayTabTitle#_titleClicked
         */

         $('.js-editor__tray__tabs__top__title_a', this.$el).on('click', this._titleClicked);
    }

    /**
     * @event TrayTabTitle#Cioui:TrayTabTitle:clicked
     * @property {String}Cioui:TrayTabTitle:clicked
     * @returns {Object} event - native click Event
     */

    _titleClicked(e){
        e.preventDefault();
        $(e.currentTarget).trigger('Cioui:TrayTabTitle:clicked', e);
    }

    /**
     * Makes the tray tab title active
     */

    setActive(){
        $('.js-editor__tray__tabs__top__title_a', this.$el).addClass('active');
    }

    /**
     * Makes the tray tab title inactive
     */

    setInActive(){
        $('.js-editor__tray__tabs__top__title_a', this.$el).removeClass('active');
    }

}
module.exports = TrayTabTitle;